module.exports = __webpack_public_path__ + "static/media/schizophreniaActive.d40c98f8.svg";